import React, { useState } from "react";
import "./AppointmentWrapper.css";
import Page1_Scheduler from "./page1_Scheduler/Page1_Scheduler";
import Page2_EnterDetails from "./page2_EnterDetails/Page2_EnterDetails";

function AppointmentWrapper() {
  const [step, setStep] = useState(1);

  const [timeSlot, setTimeSlot] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");

  return (
    <>
      <section className="AppointmentWrapper">
        <div className="container">
          {step === 1 && (
            <Page1_Scheduler
              next={() => setStep(2)}
              timeSlot={timeSlot}
              setTimeSlot={setTimeSlot}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />
          )}
          {step === 2 && (
            <Page2_EnterDetails
              back={() => setStep(1)}
              timeSlot={timeSlot}
              selectedDate={selectedDate}
            />
          )}
        </div>
      </section>
    </>
  );
}

export default AppointmentWrapper;
